export default __webpack_public_path__ + "static/media/slide2.c81d3404.png";